import React from "react";

const Pill = ({ children, className = "" }) => (
  <span
    className={`inline-flex h-12 w-12 md:h-14 md:w-14 rounded-full items-center justify-center text-white font-display tracking-tight ${className}`}
    style={{
      boxShadow: "inset 0 0 0 2px rgba(255,255,255,0.18), 0 2px 8px rgba(0,0,0,0.5)",
    }}
  >
    {children}
  </span>
);

/**
 * Real trust badges that match what is printed on the Tenaci-T bottle.
 * Rendered as small inline SVG / typographic seals to keep weight low and
 * sidestep any trademark / 3rd-party logo usage concerns.
 */
export const TrustBadges = ({ className = "" }) => {
  const items = [
    {
      ring: "bg-[#0B2B6F]",
      label: "FDA",
      sub: "Registered Facility",
    },
    {
      ring: "bg-[#1F7A38]",
      label: "LAB",
      sub: "3rd-Party Tested",
    },
    {
      ring: "bg-[#0B2B6F]",
      label: "GMP",
      sub: "Good Manufacturing",
    },
    {
      ring: "bg-[#1F7A38]",
      label: "USA",
      sub: "Made in the USA",
    },
    {
      ring: "bg-[#1F7A38]",
      label: "ECO",
      sub: "Recyclable Bottle",
    },
  ];

  return (
    <div
      className={`grid grid-cols-2 sm:grid-cols-5 gap-4 ${className}`}
      data-testid="trust-badges"
    >
      {items.map((b, i) => (
        <div
          key={i}
          className="flex items-center gap-3"
          data-testid={`trust-${b.label.toLowerCase()}`}
        >
          <Pill className={b.ring}>
            <span className="text-[10px] tracking-[0.18em] leading-none">
              {b.label}
            </span>
          </Pill>
          <div className="min-w-0">
            <div className="font-display tracking-widest uppercase text-[11px] md:text-xs text-white">
              {b.sub}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
